import { Component, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-promotion-badge',
    templateUrl: './badge.component.html',
    imports: [IconCustomComponent],
})
export class BadgeComponent {
    sitecore = inject(Sitecore);

    promotionTitle: string;

    constructor() {
        const sitecore = this.sitecore;

        this.promotionTitle = sitecore.crmPromotions.Promotion;
    }
}
